import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from "../../../models/app-filter.model";
import { AbDistribuidor } from "app/abstract/full-pages/distribuidor/distribuidor.abstract";

@Injectable({ providedIn: 'root' })
export class DistribuidorService extends AbDistribuidor {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativarDistribuidor(id: number) {
        return this.delete('admin/distribuidores/desativar/', id);
    }

    public getAllDistribuidores(filter: AppFilter) {
        return this.get('admin/distribuidores/filter/' + filter.encode());
    }

    public formatarData(data: any): Date {
        if (!data) return;

        let tempData = Object.assign({}, data);
        let newDate = new Date();
        newDate.setDate(tempData.day);
        newDate.setMonth(tempData.month - 1);
        newDate.setFullYear(tempData.year);
        return newDate;
    }

    public tratarData(data): void {
        let tempData = JSON.parse(JSON.stringify(data));
        if (tempData.match(/[/-]/g)) {
            tempData = tempData.split(/[/-]/g);
            tempData = { year: Number(tempData[0]), month: Number(tempData[1]), day: Number(tempData[2]) };
        }
        return tempData;
    }
}